/**
 * TODO make sortable everything have tagName or column or row
 * */
export default
{
  init (canvas) {
    canvas.find('.row').sortable({
      items: '> .column',
      connectWith: '.ge-canvas .row',
      handle: '> .ge-tools-drawer .ge-move',
      start: sortStart,
      tolerance: 'pointer',
      helper: 'clone'
    })
    canvas.add(canvas.find('.column')).sortable({
      items: '> .row, > .ge-content',
      connectsWith: '.ge-canvas, .ge-canvas .column',
      handle: '> .ge-tools-drawer .ge-move',
      start: sortStart,
      helper: 'clone'
    })
  },

  getTool() {
    return {title:'Move', className: 'ge-move', iconClass: 'fa fa-arrows-alt', eventHandlers: null}
  },

  //TODO not working
  initTool($handle, $el) {
    // return $('.templateWrapper').sortable({
    //   handle: $handle,
    //   start: sortStart,
    //   helper: 'clone'
    // })
  },

  deinit () {
    $('.templateWrapper .ui-sortable').sortable('destroy')
  }
}

/** HELPERS SIMPLE FUNCTIONS**/
function sortStart (e, ui) {
  ui.placeholder.css({height: ui.item.outerHeight()})
}
